<div
  class="grit-overlay-content-wrapper"
  [ngClass]="{
    modal: _overlayType === 'modal',
    'right-sheet': _overlayType === 'rightSheet',
    'bottom-sheet': _overlayType === 'bottomSheet',
    sticky: footerSticky
  }"
>
  <section class="grit-overlay-header" *ngIf="this.showCloseIcon || this.title">
    <div class="grit-overlay-title">
      <ng-content
        select="[grit-overlay-title], grit-overlay-title, [gritOverlayTitle]"
      ></ng-content>
    </div>

    <button
      *ngIf="this.showCloseIcon"
      class="grit-overlay-close"
      tabindex="0"
      pgButton
      color="secondary-light"
      (click)="closeSheet()"
    >
      <pg-icon>close</pg-icon>
    </button>
  </section>
  <section class="grit-overlay-content-body" #bodyContent>
    <ng-content></ng-content>
  </section>
  <section class="grit-overlay-content-footer" *ngIf="footer">
    <ng-content
      select="[grit-overlay-footer], grit-overlay-footer, [gritOverlayFooter]"
    ></ng-content>
  </section>
</div>
